import { Star } from "lucide-react";

export interface TestimonialData {
  name: string;
  location: string;
  text: string;
  service: string;
  rating?: number;
}

interface TestimonialCardProps {
  testimonial: TestimonialData;
  className?: string;
}

export function TestimonialCard({ testimonial, className = "" }: TestimonialCardProps) {
  const rating = testimonial.rating || 5;

  return (
    <div className={`bg-card border border-border p-6 rounded-lg shadow-sm flex flex-col h-full ${className}`}>
      <div className="flex gap-1 mb-4">
        {Array.from({ length: 5 }).map((_, i) => (
          <Star 
            key={i} 
            className={`h-5 w-5 ${i < rating ? 'text-primary fill-current' : 'text-muted-foreground'}`} 
          />
        ))}
      </div>
      
      <blockquote className="text-card-foreground flex-grow mb-6 italic leading-relaxed">
        "{testimonial.text}"
      </blockquote>
      
      <div className="mt-auto border-t border-border pt-4">
        <div className="font-bold text-foreground">{testimonial.name}</div>
        <div className="text-sm text-muted-foreground">{testimonial.location}</div>
        <div className="text-xs font-medium text-primary mt-1 px-2 py-1 bg-primary/10 inline-block rounded">
          {testimonial.service}
        </div>
      </div>
    </div>
  );
}
